import { modelVersions } from '../services/constants';
import readSettingsPotplanten from './readSettingsPotplanten';
/**
 * @typedef {import('../services/parameters').TConfigModelSubstrateRaw} TConfigModelSubstrateRaw
 * @typedef {Object} TCongifModelPotplantsRaw
 * @typedef {import('../services/constants').TModelVersion} TModelVersion
 * @typedef {import('../services/constants').TDrainType} TDrainType
 * @typedef {import('../services/parameters').TIonParameter} TIonParameter
 *
 * @typedef {string[]} TPhasesConfig
 *
 * @typedef {Object.<string, number>} TStreefwaardenConfig
 *
 * @typedef {Object} TDrainTypeConfig
 * @property {TPhasesConfig} phases
 * @property {TStreefwaardenConfig[]} streefwaarden
 *
 * @typedef TSubstrateConfig
 * @property {string} substrate - the name (identifier) of the substrate, ie. "steenwol"
 * @property {boolean} drainReuse - (drain_hergebruik) drain reuse possible
 * @property {boolean} chlorine - chlorine possible
 * @property {Object} draintypeConfig - Config per drain type
 * @property {TDrainTypeConfig} draintypeConfig.vt
 * @property {TDrainTypeConfig} draintypeConfig.gt
 *
 * @typedef {Object} TCropConfig
 * @property {string} crop - The crop name, ie "Hippeastrum"
 * @property {TSubstrateConfig[]} substrates - Possibile substrates with their configuration
 *
 * @typedef {Object} TConfig
 * @property {Object} general
 * @property {TCropConfig[]} cropList
 * @property {TIonParameter[]} ionParameters
 *
 */
/**
 *
 * @ param {TConfigModelSubstrateRaw|TCongifModelPotplantsRaw} raw
 * @param {TConfigModelSubstrateRaw} raw
 * @param {TModelVersion} modelVersion
 * @returns {TConfig}
 */
const readSettings = (raw, modelVersion) => {
    if (modelVersion === modelVersions.potplant) {
        return readSettingsPotplanten(raw, modelVersion);
    }

    return {
        cropList: Object.entries(raw.crop)
            .map(([cropKey, cropConfig]) => {
                const substrates = Object.entries(cropConfig)
                    .filter(
                        ([, substrateConfigRaw]) =>
                            substrateConfigRaw.gebruikbaar
                    )
                    .map(([substrateKey, substrateConfigRaw]) => {
                        const vdConfig = {
                            phases: substrateConfigRaw['phases vd'],
                            streefwaarden:
                                substrateConfigRaw['streefwaarden vd'],
                        };
                        const gtConfig = {
                            phases: substrateConfigRaw['phases gt'],
                            streefwaarden:
                                substrateConfigRaw['streefwaarden gt'] ??
                                substrateConfigRaw['streefwarden gt'],
                        };

                        const substrateConfig = {
                            substrate: substrateKey,
                            drainReuse: substrateConfigRaw.drain_hergebruik,
                            chlorine: substrateConfigRaw.chlorine,
                            draintypeConfig: {
                                vd: vdConfig,
                                gt: gtConfig,
                            },
                        };
                        return substrateConfig;
                    });

                const cropOption = {
                    crop: cropKey,
                    substrates,
                };

                return cropOption;
            })
            .sort((a, b) => a.crop.localeCompare(b.crop)),
        ionParameters: raw.ionParameters,
    };
};

export default readSettings;
